import React from 'react';
import { useParams } from 'react-router-dom';
import { useAdminApp } from '@/modules/admin/context/AdminAppContext';
import AdminChargesSection from '@/modules/admin/components/AdminChargesSection';

export default function AdminAppChargesPage() {
  const { appId } = useParams();
  const { app, showToast } = useAdminApp();

  return (
    <div className="mt-6">
      <AdminChargesSection
        appId={appId}
        appName={app?.name || ''}
        preferredCurrency={app?.preferredCurrency}
        showToast={showToast}
      />
    </div>
  );
}
